import get from 'lodash/get'

import {
  clearRemoteOrderTotal,
  fetchRemoteOrderTotal,
  fetchRemoteOrderTotalSucceeded,
  fetchRemoteOrderTotalFailed,
  fetchRemoteOrderTotalUpdate,
} from '../actions/orderTotalRemote'

import { formatOrderTotals } from '../utils/orderTotalUtils'

const defaultState = {
  loading: true,
  failed: false,
  isAvailable: false,
  hash: null,
}

const reducer = (state = defaultState, action) => {
  const clear = clearRemoteOrderTotal.type
  const requested = fetchRemoteOrderTotal.type
  const succeeded = fetchRemoteOrderTotalSucceeded.type
  const update = fetchRemoteOrderTotalUpdate.type
  const failed = fetchRemoteOrderTotalFailed.type

  switch (action.type) {
    case clear:
      return defaultState

    case requested: {
      const orderUuid = get(action, 'payload.orderUuid', '')

      return {
        orderUuid,
        loading: true,
        failed: false,
        updatedAt: undefined,
        hash: null,
      }
    }

    case succeeded: {
      const data = action?.payload?.result?.data ?? {}
      const useTaxClasses = action?.payload?.useTaxClasses ?? false
      const taxExempt = action?.payload?.taxExempt ?? false
      const updatedAt = new Date()

      return {
        ...state,
        ...formatOrderTotals(data, useTaxClasses, taxExempt),
        updatedAt,
        loading: false,
        failed: false,
        isAvailable: true,
        hash: action?.payload?.hash,
      }
    }

    case update: {
      const data = action?.payload
      const updatedAt = new Date()

      return {
        ...state,
        ...data,
        updatedAt,
      }
    }

    case failed: {
      const data = get(action, 'payload.response.data', {})

      return {
        ...data,
        loading: false,
        failed: true,
        isAvailable: false,
        updatedAt: undefined,
        hash: null,
      }
    }

    default:
      return state
  }
}

export default reducer
